<template>
    <div class="col-sm-12 d-flex flex-wrap py-3">
        <div class="col-sm-6 d-flex flex-column h-100">
            <client-form class="flexGrow1" :disabled="disabled" :customer="reservation.customer" :bookingComponents="reservation.bookingComponents" :transport="reservation.transport" :reservation="reservation"></client-form>
        </div>

        <div class="col-sm-6">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-12 border-light radius-normal">
                        <checkins :disabled="disabled" :reservation="reservation"></checkins>
                    </div>
                </div>

                <div class="col-sm-12 mt-2">
                    <div class="col-sm-12 border-light radius-normal">
                        <price-total :disabled="disabled" :reservation="reservation"></price-total>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { reservationsMixin } from '@/mixins/reservations'

    import ClientForm from './TabDetails/ClientForm'
    import Checkins from './TabDetails/Checkins'
    import PriceTotal from './TabDetails/PriceTotal'

    export default {
        data() {
            return {}
        },
        props: {
            reservation: {
                type: Object
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        components: {
            ClientForm,
            Checkins,
            PriceTotal
        },
        mixins: [
            reservationsMixin
        ]
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// TabDetails.vue?fc048f44